<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by James Silvester</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content"><span class="underline">Lucie Musilova Series</span></p>
<p class="subsq also-by-content">Blood, Blue and White</p>
<p class="subsq also-by-content">Sealed with Death</p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content"><span class="underline">Prague Thrillers</span></p>
<p class="subsq also-by-content">The Prague Ultimatum</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-james-silvester.vue?551d266f